export default __webpack_public_path__ + "static/media/firsAidKit.2cbff8c4.svg";